import { makeAutoObservable } from 'mobx'
import { SignedDocumentRequest } from '../requests/SignedDocumentRequest'

class SignedDocumentStore {
  documentSignedList = []
  userDetail = {}
  totalCount = 0
  pageIndex = 0
  pageSize = 10
  keyword = undefined

  constructor() {
    makeAutoObservable(this)
  }

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }
  getAllDocumentSigned = () => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.getAllDocumentSigned(
        this.pageSize,
        this.pageIndex,
        this.keyword
      )
        .then(response => {
          const data = response.data.data
          const totalCount = response.data.totalElements
          this.documentSignedList = data
          this.totalCount = totalCount
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
  eSignDocument = formData => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.eSignDocument(formData)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
  deleteDocumentSigned = signedId => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.deleteDocumentSigned(signedId)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
  downloadDocumentSigned = fileId => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.downloadDocumentSigned(fileId)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  // Ký số savis
  fileBlob = null
  signatureList = undefined
  pageSignatureIndex = 0
  pageSignatureSize = 5
  signatureTotalCount = 0
  originFileObj = null

  clearSignatureStore = () => {
    this.pageSignatureIndex = 0
    this.pageSignatureSize = 5
  }

  setFileBlob = file => {
    this.fileBlob = file
  }

  setOriginFileObj = file => {
    this.originFileObj = file
  }

  getSignatureList = filter => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.getSignatureList(
        this.pageSignatureIndex,
        this.pageSignatureSize,
        filter
      )
        .then(response => {
          this.signatureTotalCount = response.data.totalElements
          this.signatureList = response.data.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  handleSignature = (idSignature, type) => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.handleSignature(idSignature, type)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  deleteSignature = signId => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.deleteSignature(signId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createSignature = data => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.createSignature(data)
        .then(response => {
          console.log(response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createSignatureBySendFileId = data => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.createSignatureBySendFileId(data)
        .then(response => {
          console.log(response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  signDocumentSavis = data => {
    // kích thước trang sẽ tính theo A4 (595x845 point
    // toạ độ [llx,lly] xác định điểm góc dưới của vùng ký
    // toạ độ [urx,ury] xác định điểm góc trên của vùng ký
    data = {
      ...data,
      llx: 300,
      lly: 794,
      urx: 590,
      ury: 830,
    }
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.signDocumentSavis(data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  // sign Savis trên trục liên thông
  signDocumentSavisTruc = data => {
    return new Promise((resolve, reject) => {
      SignedDocumentRequest.signDocumentSavisTruc(data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  clearSignedDocumentListStore = () => {
    this.documentSignedList.length = 0
    this.totalCount = 0
    this.pageIndex = 0
    this.pageSize = 10
    this.keyword = undefined
    this.signatureList = undefined
    this.pageSignatureIndex = 0
    this.pageSignatureSize = 100
  }
  clearDataPopupSign = () => {
    this.fileBlob = undefined
    this.originFileObj = null
    this.responseSign = undefined
  }

  clearSignatureList = () => {
    this.signatureList = undefined
    this.pageSignatureIndex = 0
    this.pageSignatureSize = 100
  }

  responseSign = undefined
  setResponseSign = res => {
    this.responseSign = res
  }

  clearFilePDFSign = () => {
    this.fileBlob = undefined
    this.originFileObj = null
    this.responseSign = undefined
  }
}

export default new SignedDocumentStore()
